export function gameViewportSize(width:number,height:number,visual?:{width:number;height:number;scale:number}|null):{width:number;height:number}{
  // Browser pinch zoom is not a layout resize. Collapsed browser chrome is.
  const usable=visual&&visual.scale===1&&visual.width>0&&visual.height>0;
  return {width:Math.max(1,Math.floor(usable?visual.width:width)),height:Math.max(1,Math.floor(usable?visual.height:height))};
}
